import { useMutation, useQuery, useQueryClient } from "react-query";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import api from "../api/api";
import useUrlQuery from "../hooks/useUrlQuery";
import { Actions } from "../slices/actions";
import { frontendBootSelector, leadDataSelector } from "../slices/selectors";

export const useGetFrontendBoot = () => {
  const { data, isLoading } = useQuery(
    ["FrontendBoot"],
    () => api.get("/travel/frontend-boot"),
    { onSuccess: (data) => Actions.setFrontendBoot(data?.data) }
  );
  return {
    frontendBoot: data?.data,
    tenant: data?.data?.traveltenant,
    settings: data?.data?.travelsettings,
    isOtpJourney: data?.data?.travelsettings?.otp_journey,
    sumInsured: data?.data?.travelsuminsured,
    isFrontendBootLoading: isLoading,
  };
};
export const useGetSellerInfo = () => {
  const { getQuery } = useUrlQuery();
  const token = getQuery("token");
  const { data, isLoading } = useQuery(
    ["User", token],
    () => api.post("dashboard/details/user", { token }),
    { enabled: !!token }
  );
  return { userData: data?.data, isUserLoading: isLoading };
};
export const useGetCountries = () => {
  const { data, isLoading } = useQuery(["Countries"], () =>
    api.get("/get/countries")
  );
  return { countries: data?.data?.data, isCountriesLoading: isLoading };
};
export const useCreateQuote = () => {
  const leadData = useSelector(leadDataSelector);
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { data, isLoading, mutate } = useMutation(
    (req) => api.post("/create/quote", { ...leadData, ...req }),
    {
      onSuccess: (data) => {
        queryClient.invalidateQueries(["Details"]);
        queryClient.removeQueries(["Plans"]);
        Actions.setTraceId(data?.data?.trace_id);
        navigate({
          pathname: "/quote",
          search: `?enquiry_id=${data.data.enquiry_id}`,
        });
      },
    }
  );
  return { isLoading, data, createQuote: mutate };
};
export const usePatchQuote = () => {
  const queryClient = useQueryClient();
  

  const { mutate } = useMutation(
    (req) =>
      api.patch("/update/quote", {
        ...req,
      }),
    {
      onSuccess: (data) => {
        queryClient.invalidateQueries(["Details"]);
        queryClient.removeQueries(["Plans"]);
      },
    }
  );

  return { patchQuote: mutate };
};
export const useSendOTP = () => {
  const frontendBootData = useSelector(frontendBootSelector);
  const leadData = useSelector(leadDataSelector);
  const { isLoading, mutate } = useMutation(
    (req) =>
      api.post(`/travel/${frontendBootData?.traveltenant?.alias}/sent_otp`, {
        ...req,
        name: leadData?.insured_name,
        mobile: leadData?.insured_mobile,
        email: leadData?.insured_email,
        section: "travel",
      }),
    {
      onSuccess: (data) => {
        Actions.setUuid(data?.data?.uuid);
        data?.data?.uuid &&
          toast.success(
            <div style={{ fontSize: ".8rem", fontWeight: "600" }}>
              OTP Send Successfully !!
            </div>
          );
      },
    }
  );
  return { isSendOtpLoading: isLoading, sendOtp: mutate };
};
export const useVerifyOTP = () => {
  const frontendBootData = useSelector(frontendBootSelector);
  const uuid = useSelector(frontendBootSelector);
  const { isLoading, mutate } = useMutation(
    (req) =>
      api.post(`/travel/${frontendBootData?.traveltenant?.alias}/verify_otp`, {
        ...req,
        uuid,
      }),
    {
      onSuccess: (data) => {
        if (data?.data?.status) {
          Actions.setActiveStep(1);
          toast.success(
            <div style={{ fontSize: ".8rem", fontWeight: "600" }}>
              Verified Successfully !!
            </div>
          );
        }
      },
      onError: (error) => {
        if (!error?.response?.data?.status)
          toast.error(
            <div style={{ fontSize: ".8rem", fontWeight: "600" }}>
              Incorrect OTP !! Check and try again.
            </div>
          );
      },
    }
  );

  return { isVerifyOtpLoading: isLoading, verifyOTP: mutate };
};
